import { useContext } from "react";
import ProvidersContext from "../store/providers-cxt";

export default function useProvidersList() {
  return useContext(ProvidersContext);
}
